/* eslint-disable block-scoped-var */
/* globals paper */
import _ from 'lodash';
import ControlPoint from './ControlPoint';

class Line {
    constructor(index, x, lineSymbol, vw, vh, showMoire, pathSegments, callBack) {
        this.controlPoints = [];

        const colorArray = [
            '#E20074', '#D7AC41', '#49708B',
        ];

        // use _.sample
        let fillColor = window.transitionColor;
        if (!fillColor) {
            fillColor = _.sample(colorArray);
        }

        this.group = new paper.Group();
        this.path = new paper.Path({
            parent: this.group,
            strokeColor: 'transparent',
            strokeWidth: 0,
            fillColor,
        });

        const modifier = 1;

        // eslint-disable-next-line block-scoped-var
        this.pathSymbol = lineSymbol.place([x, (vh / modifier)]);

        this.pathSymbol.parent = this.group;
        this.pathSymbol.visible = showMoire;

        const segments = [];

        for (let i = 0; i <= pathSegments; i++) {
        // var points = [
        //   200,
        //   vw / 2,
        //   1200
        // ];

            var x = i / pathSegments * vw; // eslint-disable-line
            // var x = points[i];

            const start = new paper.Point(x, vh / modifier);
            const canMove = (i && i !== pathSegments);
            const controlPoint = new ControlPoint(i, this, this.path, start, canMove, callBack);

            this.controlPoints.push(controlPoint);
            segments.push(start);
        }

        this.path.addSegments(segments);

        this.index = index;
        this.x = x;
    }

    destroy() {
        this.group.remove();

        // eslint-disable-next-line no-restricted-syntax
        for (const controlPoint of this.controlPoints) {
            controlPoint.destroy();
        }

        // eslint-disable-next-line no-restricted-syntax, guard-for-in
        for (const prop in this) {
            this[prop] = null;
        }
    }

    update() {
        // let hasChanges = false;
        // const total = this.path.segments.length - 1;

        // for (let i = 1; i < total; i++) {
        //     if (this.controlPoints[i].refresh()) {
        //         hasChanges = true;
        //     }
        // }

        // if (hasChanges) {
        // this.path.visible = true;
        // this.pathSymbol.visible = showMoire;
        this.smoothPath();
        // } else {
        //     this.path.visible = false;
        //     this.pathSymbol.visible = true;
        // }
    }

    smoothPath() {
        this.path.smooth({ type: 'geometric', factor: 0.3 });
    }
}

export default Line;
